import PropTypes from 'prop-types';

import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

const SideEntry = ({
	label,
	status,
	desc,
	typo,
	labelDownload,
	linkDownload,
}) => (
	<Stack>
		{label && (
			<Stack gap={0.5} direction="row" alignItems="baseline">
				<Typography variant="subtitle1">{label}</Typography>
				{status && <Chip size="small" variant="combined" {...status} />}
			</Stack>
		)}

		{desc && (
			<Stack spacing={0.5} direction="row">
				<Typography variant="body2" color={typo?.color || 'secondary'}>
					{desc}
				</Typography>
				{linkDownload && (
					<Link
						variant="body2"
						color="secondary"
						underline="none"
						download
						{...linkDownload}
					>
						<ArrowDownwardIcon sx={{ fontSize: 16, my: -0.5 }} />
						{labelDownload}
					</Link>
				)}
			</Stack>
		)}
	</Stack>
);

SideEntry.propTypes = {
	label: PropTypes.string,
	status: PropTypes.shape(Chip.propTypes),
	desc: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	typo: PropTypes.shape(Typography.propTypes),
	labelDownload: PropTypes.string,
	linkDownload: PropTypes.shape(Link.propTypes),
	id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default SideEntry;
